module.exports = __webpack_public_path__ + "img/POP-00014-3.dbd2d3b9.png";